angular.module('shbdeployer.app').controller('ProjectsController', [
  '$q',
  '$scope',
  '$state',
  'ProjectService',
  'EndpointService',
  'SettingsService',
  'ModalService',
  'Authentication',
  'Notifications',
  function ($q, $scope, $state, ProjectService, EndpointService, SettingsService, ModalService, Authentication, Notifications) {
    $scope.state = {
      actionInProgress: false,
    };

    $scope.isAdmin = Authentication.isAdmin();

    $scope.endpointName = function (endpointId) {
      var endpoint = $scope.endpointsById[endpointId];
      return endpoint ? endpoint.Name : '—';
    };

    $scope.projectUrl = function (project) {
      if (!$scope.baseDomain || !project.Subdomain) {
        return '';
      }
      return 'https://' + project.Subdomain + '.' + $scope.baseDomain;
    };

    $scope.removeAction = function (project) {
      ModalService.confirmDeletion(
        'Проект и все его данные (включая развёрнутые контейнеры) будут удалены без возможности восстановления. Продолжить?',
        function onConfirm(confirmed) {
          if (!confirmed) {
            return;
          }
          deleteProject(project);
        }
      );
    };

    function deleteProject(project) {
      $scope.state.actionInProgress = true;
      ProjectService.remove(project.Id)
        .then(function success() {
          Notifications.success('Проект удален', project.Name);
          $state.reload();
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось удалить проект');
        })
        .finally(function final() {
          $scope.state.actionInProgress = false;
        });
    }

    function initView() {
      $q.all({
        projects: ProjectService.projects(),
        endpoints: EndpointService.endpoints(undefined, undefined, { types: [1, 2] }),
        settings: SettingsService.publicSettings(),
      })
        .then(function success(data) {
          $scope.projects = data.projects;
          $scope.endpointsById = {};
          angular.forEach(data.endpoints.value, function (endpoint) {
            $scope.endpointsById[endpoint.Id] = endpoint;
          });
          $scope.baseDomain = data.settings.BaseDomain;
        })
        .catch(function error(err) {
          $scope.projects = [];
          $scope.endpointsById = {};
          Notifications.error('Ошибка', err, 'Не удалось получить список проектов');
        });
    }

    initView();
  },
]);
